import * as React from 'react';

import { SvgButton, color } from '@coursera/coursera-ui';
import { SvgAdd, SvgEdit, SvgTrash } from '@coursera/coursera-ui/svg';

import type { Option } from 'bundles/widget-simulator/types';

import _t from 'i18n!nls/widget-simulator';

import 'css!./__styles__/OptionsFormGroup';

type Props = {
  label: string;
  children: React.ReactNode;
  options: Array<Option>;
  selectedOption: Option | undefined;
  onAddButtonClick: () => void;
  onEditButtonClick: () => void;
  onRemoveButtonClick: () => void;
};

const OptionsFormGroup = ({
  label,
  children,
  options,
  selectedOption,
  onAddButtonClick,
  onEditButtonClick,
  onRemoveButtonClick,
}: Props) => {
  const hasSelectedOption = options && options.length > 0 && !!selectedOption;

  return (
    <div className="rc-OptionsFormGroup m-b-1">
      <div className="horizontal-box">
        {label && <div className="form-label m-r-1">{label}</div>}
        <div className="flex-1 control-container">{children}</div>
        <div className="button-container">
          <SvgButton
            size="zero"
            onClick={onAddButtonClick}
            svgElement={<SvgAdd title={_t('Add')} size={14} hoverColor={color.white} />}
            data-test="add-btn"
          />
          <SvgButton
            size="zero"
            onClick={onEditButtonClick}
            disabled={!hasSelectedOption}
            data-test="edit-btn"
            svgElement={<SvgEdit title={_t('Edit')} size={14} hoverColor={color.white} />}
          />
          <SvgButton
            size="zero"
            onClick={onRemoveButtonClick}
            disabled={!hasSelectedOption}
            data-test="delete-btn"
            svgElement={<SvgTrash title={_t('Delete')} size={14} hoverColor={color.white} />}
          />
        </div>
      </div>
    </div>
  );
};

export default OptionsFormGroup;
